import React from 'react'
import { Skeleton, Box } from '@mui/material'
import { ButtonIconSeeker } from '@ui-seeker/core'

import { useToast } from '@hooks'
import { BACKEND_APIS } from '@constants'
import { TitleWithPopover, AppTableSeeker } from "@components";
import { numColumn, nameColumn } from './columns'
import { useCustomersKeywordsTableFilters} from "./@hooks";
import { customerDetailsFilters } from "../@signals";


export default function CustomersKeywordsTable() {

    const { data, isLoading, customerHasKeywords } = useCustomersKeywordsTableFilters()
    const { showToast } = useToast()

    if (isLoading) return <Skeleton variant="rectangular" height={500} />
    if (customerHasKeywords === null) return <></>

    const columns = [
        numColumn('keywordID', 'Keyword ID'),
        nameColumn()
    ]

    return <Box id="customer-keywords-info">
        <AppTableSeeker
            data={data}
            title={<TitleWithPopover title={"Keywords info for customer " + customerDetailsFilters.value?.name} />}
            columns={columns}
            options={{
                tableBodyHeight: '600',
                onDownload: () => showToast.promiseExcel(`${BACKEND_APIS.MANAGEMENT}/customer/customer-keywords-excel`, customerDetailsFilters.value),
                viewColumns: false,
                customToolbar: () => <ButtonIconSeeker
                    icon="circle-xmark"
                    onClick={() => {
                        customerDetailsFilters.value = {}
                    }}
                    tooltip="Close Customer Details"
                />
            }}
            textLabels= {{
                body: {
                    noMatch: 'There don’t seem to be any keywords configured for the selected customer.'
                }
            }}
        />
    </Box>
}